import { ChangeTierButton } from "./cta"
import { BasePartnershipTierSelectorItem } from "../Base"
import { ChangePartnershipTierSelectorItemTierFragment } from "__generated__/ChangePartnershipTierSelectorItemTierFragment"
import { ChangePartnershipTierSelectorItemApplylistFragment } from "__generated__/ChangePartnershipTierSelectorItemApplylistFragment"

type ChangePartnershipTierSelectorItemProps = {
    applylist: ChangePartnershipTierSelectorItemApplylistFragment
    partnershipTier: ChangePartnershipTierSelectorItemTierFragment
}

export const ChangePartnershipTierSelectorItem = (
    props: ChangePartnershipTierSelectorItemProps
) => {
    return (
        <BasePartnershipTierSelectorItem
            {...props}
            cta={<ChangeTierButton {...props} />}
        />
    )
}
